import { render, staticRenderFns } from "./ColourAndExtrasOptionalEquipment.vue?vue&type=template&id=61a03bdc&scoped=true&"
import script from "./ColourAndExtrasOptionalEquipment.vue?vue&type=script&lang=js&"
export * from "./ColourAndExtrasOptionalEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a03bdc",
  null
  
)

export default component.exports